var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TimeSince',{attrs:{"date":_vm.date},scopedSlots:_vm._u([{key:"default",fn:function(interval){return [_vm._v(" "+_vm._s(_vm.timeSince(interval))+" "+_vm._s(_vm.getNameByKey('ago'))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }